const Footer = (): JSX.Element => {
  return (
    <footer>
      <ul className="list-unstyled m-0 p-0 d-flex justify-content-center discovery-hover-underline">
        <li className="mb-2 px-3">
          <a href="https://talis.com/legal">Legal</a>
        </li>
        <li className="mb-2 px-3">
          <a href="https://talis.com/gdpr">GDPR</a>
        </li>
        <li className="mb-2 px-3">
          <a href="https://uk.sagepub.com/sites/default/files/sage_catalyst_aspire_audit.pdf">
            Accessibility
          </a>
        </li>
        <li className="mb-2 px-3">
          <a href="http://catalystsolutions.sagepub.com/support/home">
            Support
          </a>
        </li>
        <li className="mb-2 px-3">
          <a href="https://sagecatalystfeedbackportal.ideas.aha.io/ideas/new">
            Give feedback
          </a>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
